import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Layout from '@components/common/Layout';
import SatInput from '@components/common/satUI/SatInput';
import {saveApplicationMenuInfo} from '@store/actions/menuAction';


const MenuInsert =  props => {
    const { saveMenuInfo, menuInfo } = useSelector(state => state.menuReducer);
    const dispatch = useDispatch();

    const {
        visible,        
        setVisible,
        menuIdRef,
        menuNmRef,
        linkUrlAddrRef,
        menuSortOrdRef,
        handlePressEnter
    } = props;

    const handleInputEvent = (value, targetId) => {
        if (targetId === 'menuId') {
          dispatch(
            saveApplicationMenuInfo({
                menuId: value,
            }),
          );
        }else if(targetId === 'menuNm') {
          dispatch(
            saveApplicationMenuInfo({
                menuNm: value,
            }),
          );
        }else if(targetId === 'menuSortOrd') {
            dispatch(
                saveApplicationMenuInfo({
                menuSortOrd: value.target.value,
              }),
            );
        }else if(targetId === 'linkUrlAddr') { 
            dispatch(
                saveApplicationMenuInfo({
                linkUrlAddr: value,
              }),
            );
        }
    };

    const handleAplctnScrenTyCd = type => {
        dispatch(
            saveApplicationMenuInfo({
            aplctnScrenTyCd: type,
          }),
        );
    };

    const handleuseYn = type => {
        dispatch(
            saveApplicationMenuInfo({
            useYn: type,
          }),
        );
    };

    const handleExtNtwkUseYn = type => {
        dispatch(
            saveApplicationMenuInfo({
            extNtwkUseYn: type,
          }),
        );
    };
    
    const handleLinkMenuYn = type => {
        dispatch(
            saveApplicationMenuInfo({
            linkMenuYn: type,
          }),
        );
    };

    const handleSsoLinkdYn = type => {
        dispatch(
            saveApplicationMenuInfo({
            ssoLinkdYn: type,
          }),
        );
    };



    return (visible && (
    <div className="table-wrap-reg">
            <div className="round-box">
                <div className="tit-area">
                    <h3>메뉴정보</h3>
                </div>
                <table className="tbl-sty2">
                    <colgroup>
                        <col width="20%;" />
                        <col width="80%;" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>
                                <span className="pilsu-box">
                                    <span className="pilsu"></span>메뉴ID
                                </span>
                            </th>
                            <td>
                                {saveMenuInfo.menuId}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <span className="pilsu-box">
                                    <span className="pilsu"></span>메뉴명
                                </span>
                            </th>
                            <td>
                                <SatInput
                                    ref={menuNmRef}
                                    value={saveMenuInfo.menuNm}
                                    type="text"
                                    border
                                    customInputClass="line1"
                                    onPressEnter={handlePressEnter}
                                    onChange={value => handleInputEvent(value, 'menuNm')}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th>상위레벨메뉴</th>
                            <td>{menuInfo.menuNm}[{menuInfo.menuId}]</td>
                        </tr>
                        <tr>
                            <th>메뉴depth</th>
                            <td>{saveMenuInfo.depth}depth</td>
                        </tr>
                        <tr>
                            <th>메뉴순서</th>
                            <td>
                                {saveMenuInfo.menuSortOrd}                          
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <span className="pilsu-box">
                                    <span className="pilsu"></span>화면유형
                                </span>
                            </th>
                            <td>
                                <div className="check-box">
                                    <div className="check-wrap">
                                        <input type="radio" name="aplctnScrenTyCd" id="aplctnScrenTyCd01" checked={saveMenuInfo.aplctnScrenTyCd === '01'} 
                                            onChange={() => saveMenuInfo.aplctnScrenTyCd !== '01' && handleAplctnScrenTyCd('01')} />
                                        <label htmlFor="aplctnScrenTyCd01">메뉴그룹</label>
                                    </div>
                                    <div className="check-wrap">
                                        <input type="radio" name="aplctnScrenTyCd" id="aplctnScrenTyCd02" checked={saveMenuInfo.aplctnScrenTyCd === '02'} 
                                            onChange={() => saveMenuInfo.aplctnScrenTyCd !== '02' && handleAplctnScrenTyCd('02')} />
                                        <label htmlFor="aplctnScrenTyCd02">메인</label>
                                    </div>
                                    <div className="check-wrap">
                                        <input type="radio" name="aplctnScrenTyCd" id="aplctnScrenTyCd03" checked={saveMenuInfo.aplctnScrenTyCd === '03'} 
                                            onChange={() => saveMenuInfo.aplctnScrenTyCd !== '03' && handleAplctnScrenTyCd('03')} />
                                        <label htmlFor="aplctnScrenTyCd03">팝업</label>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <span className="pilsu-box">
                                    <span className="pilsu"></span>표시여부
                                </span>
                            </th>
                            <td>
                                <div className="check-box">
                                    <div className="check-wrap">
                                        <input type="radio" name="useYn" id="useYn01" checked={saveMenuInfo.useYn === 'Y'} 
                                            onChange={() => saveMenuInfo.useYn !== 'Y' && handleuseYn('Y')} />
                                        <label htmlFor="useYn01">표시</label>
                                    </div>
                                    <div className="check-wrap">
                                        <input type="radio" name="useYn" id="useYn02" checked={saveMenuInfo.useYn === 'N'} 
                                            onChange={() => saveMenuInfo.useYn !== 'N' && handleuseYn('N')} />
                                        <label htmlFor="useYn02">표시안함</label>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <span className="pilsu-box">
                                    <span className="pilsu"></span>외부사용여부
                                </span>
                            </th>
                            <td>
                                <div className="check-box">
                                     <div className="check-wrap">                                        
                                        <input type="radio" name="extNtwkUseYn" id="extNtwkUseYn01" checked={saveMenuInfo.extNtwkUseYn === 'Y'} 
                                            onChange={() => saveMenuInfo.extNtwkUseYn !== 'Y' && handleExtNtwkUseYn('Y')} />
                                        <label htmlFor="extNtwkUseYn01">사용</label>
                                    </div>
                                    <div className="check-wrap">
                                        <input type="radio" name="extNtwkUseYn" id="extNtwkUseYn02" checked={saveMenuInfo.extNtwkUseYn === 'N'} 
                                            onChange={() => saveMenuInfo.extNtwkUseYn !== 'N' && handleExtNtwkUseYn('N')} />
                                        <label htmlFor="extNtwkUseYn02">미사용</label>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>링크메뉴여부</th>
                            <td>
                                <div className="check-box">
                                    <div className="check-wrap">                                        
                                        <input type="radio" name="linkMenuYn" id="linkMenuYn01" checked={saveMenuInfo.linkMenuYn === 'Y'} 
                                            onChange={() => saveMenuInfo.linkMenuYn !== 'Y' && handleLinkMenuYn('Y')} />
                                        <label htmlFor="linkMenuYn01">사용</label>
                                    </div>
                                    <div className="check-wrap">                                        
                                        <input type="radio" name="linkMenuYn" id="linkMenuYn02" checked={saveMenuInfo.linkMenuYn === 'N'} 
                                            onChange={() => saveMenuInfo.linkMenuYn !== 'N' && handleLinkMenuYn('N')} />
                                        <label htmlFor="linkMenuYn02">미사용</label>
                                    </div>
                                </div>
                            </td>
                        </tr>                        
                        <tr>
                            <th>
                                <span className="pilsu-box">
                                    <span className="pilsu"></span>링크URL
                                </span>
                            </th>
                            <td>                                
                                <SatInput
                                    ref={linkUrlAddrRef}
                                    value={saveMenuInfo.linkUrlAddr}
                                    type="text"
                                    id="linkUrlId" 
                                    border
                                    customInputClass="line1"
                                    onPressEnter={handlePressEnter}
                                    onChange={value => handleInputEvent(value, 'linkUrlAddr')}
                                />  
                            </td>
                        </tr>
                        <tr>
                            <th>SSO연동여부</th>
                            <td>
                                <div className="check-box">
                                    <div className="check-wrap">
                                        <input type="radio" name="ssoLinkdYn" id="ssoLinkdYn01" checked={saveMenuInfo.ssoLinkdYn === 'Y'} 
                                            onChange={() => saveMenuInfo.ssoLinkdYn !== 'Y' && handleSsoLinkdYn('Y')} />
                                        <label htmlFor="ssoLinkdYn01">사용</label>
                                    </div>
                                    <div className="check-wrap">                                        
                                        <input type="radio" name="ssoLinkdYn" id="ssoLinkdYn02" checked={saveMenuInfo.ssoLinkdYn === 'N'} 
                                            onChange={() => saveMenuInfo.ssoLinkdYn !== 'N' && handleSsoLinkdYn('N')} />
                                        <label htmlFor="ssoLinkdYn02">미사용</label>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div className="text-info">
                    <span className="ico ico-info-yellow"></span>
                    메뉴목록에서 선택한 메뉴의 하위레벨으로만 추가가 가능합니다. 상위레벨 메뉴를 선택하세요.
                </div>
            </div>
        </div>
        )
    );
};

export default MenuInsert;